import { render, staticRenderFns } from "./update-mainlandorder-statu.vue?vue&type=template&id=02468c5a"
import script from "./update-mainlandorder-statu.vue?vue&type=script&lang=ts"
export * from "./update-mainlandorder-statu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports